import { CampaignGroupIdSchema } from '@hprofits/shared';

import { useRouteParam } from '@/modules/common/route/useRouteParam';

export const useCampaignRoute = () => ({ campaignGroupId: useRouteParam('id', CampaignGroupIdSchema) });
